import { combineReducers } from 'redux';
import { CaseLibraryProcessSearch } from '../../views/CaseLibrary/CaseLibraryProcess/reducer';
//定义数据
const defaultState = {
  contacter: '', // 用户名
  message: [], // 消息
  notice: [], // 通知
  crmAccountId: '',
}

// 导出一个方法，这个方法有state和action参数，返回state
function rootState (state = defaultState, action) {
  switch (action.type) {
    case 'SET_NAME':
      return { ...state, contacter: action.payload.name }
    case 'SET_MESSAGE':
      return { ...state, message: action.payload.message }
    case 'SET_NOTICE':
      return { ...state, notice: action.payload.notice }
    case 'SET_CRM_ACCOUNT_ID': 
      return { ...state, crmAccountId: action.payload.crmAccountId }
    case 'CLEAR_MESSAGE':
      return { ...state, message: [] }
    case 'CLEAR_NOTICE':
      return { ...state, notice: [] }
    default:
      return state
  }
}

export default combineReducers({
  rootState,
  CaseLibraryProcessSearch,
});